import { render, staticRenderFns } from "./AppRegularNewFooterLayout.vue?vue&type=template&id=18519110&"
import script from "./AppRegularNewFooterLayout.vue?vue&type=script&lang=js&"
export * from "./AppRegularNewFooterLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports